import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const MOPED = {
  nickname: 'PRODUCTS.MOPED.nickname',
  properties: [
    { name: 'vehicleLicenseNumber', key: 'LICENSE_NUMBER', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'tffVehicleBrand', key: 'TFF_VEHICLE_BRAND', group: 'OBJECT_INFO'},
    { name: 'tffVehicleModel', key: 'TFF_VEHICLE_MODEL', group: 'OBJECT_INFO'},
    { name: 'calculatedClientAge', key: 'CLIENT_AGE', group: 'OBJECT_INFO' },
    {
      name: 'ofvFirstTimeRegYear', key: 'OFV_FIRST_TIME_REG_YEAR', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.DATE,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        dateView: 'multi-years'
      }
    },
    { name: 'vehicleDriverAccident', key: 'VEHICLE_DRIVER_ACCIDENT', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'vehicleRegistrationYear', key: 'REGISTRATION_YEAR', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.DATE,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        dateView: 'multi-years'
      }
    },
    { name: 'vehicleYoungDriver', key: 'YOUNG_DRIVER', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'objectZipCode', key: 'OBJECT_ZIP', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.required,
        Validators.pattern('[0-9]{4}$')
      ]],
      customProductTypeConfig: {
        VETERAN_CAR: {
          key: 'OBJECT_ZIP_MOPED'
        }
      }
    },
    { name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.ANSVAR', value: 'Ansvar' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.DELKASKO', value: 'Delkasko' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.KASKO', value: 'Kasko' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.BRANN_TYVERI', value: 'BrannTyveri' },
        ]
      }
    },
    { name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_MOPED.5', value: 5000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_MOPED.75', value: 7500 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_MOPED.10', value: 10000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_MOPED.15', value: 15000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_MOPED.20', value: 20000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_MOPED.25', value: 25000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_MOPED.30', value: 30000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_DEDUCTIBLE_MOPED.50', value: 50000 }
        ]
      }
    }
  ]
};
